module.exports = __webpack_public_path__ + "media/assets/images/layout/icon-null-circle-0b44ef4d911fb237a57541293a4428a7.png";